import { GET_PROMOTIONS } from '../actions/promotion';
const initialState = {
    promotions: []
};

export default function promotionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PROMOTIONS:
            return {
                ...state,
                ...(action.payload && action.payload.promotions && {promotions: action.payload.promotions})
            };
        default:
            return state;
    }
}